import { CancelOutlined, CheckCircleOutline } from '@mui/icons-material';
import moment from 'moment';
import React, { useState } from 'react';

import invoiceSrc from '../../../assets/invoice-w.png';
import { sendPaymentLink } from '../api/invoice';
import { Button } from '@/components/Elements';

const AddInvoice = ({ data, closeDialog }: any) => {
    const [confirm, setConfirm] = useState<boolean>(true);
    const a = moment(data.promiseTime);
    const b = moment(Date.now());
    const diff_s = a.diff(b, 'minutes');
    const handleSendInvoice = async () => {
        try {
            const params = {
                cart_group_id: data?.cartId,
                email: data?.user_active ? data?.user_email : data?.corporate_email,
                name: data?.user_active
                    ? data?.first_name + ' ' + data?.last_name
                    : data?.corporate_name,
                ...(data?.order_type_id == '18' && {
                    lat: String(data?.lat),
                    long: String(data?.long),
                    order_delivery_address: data?.address,
                }),
            };
            await sendPaymentLink(params)
                .then((res) => setConfirm(false))
                .catch((err) => console.log('error while sending payment link-->', err));
        } catch (err) {
            console.log('error from handle send invoice-->', err);
        }
    };

    return (
        <div className="modal-dialog">
            <div className="modal-content">
                {confirm ? (
                    <>
                        <div className="modal-header">
                            <h5 className="modal-title" id="createorderModalLabel">
                                Send Invoice
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => closeDialog()}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="invoice-header">
                                <p className="text-center f-18">Invoice will be send to email:</p>
                                <div className="mail-box f-18">
                                    <svg
                                        style={{ marginRight: '10px' }}
                                        width="23"
                                        height="18"
                                        viewBox="0 0 23 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M21.5 0H1.5C1.23478 0 0.98043 0.105357 0.792893 0.292893C0.605357 0.48043 0.5 0.734784 0.5 1V17C0.5 17.2652 0.605357 17.5196 0.792893 17.7071C0.98043 17.8946 1.23478 18 1.5 18H21.5C21.7652 18 22.0196 17.8946 22.2071 17.7071C22.3946 17.5196 22.5 17.2652 22.5 17V1C22.5 0.734784 22.3946 0.48043 22.2071 0.292893C22.0196 0.105357 21.7652 0 21.5 0ZM20.5 16H2.5V6.477L11.128 9.929C11.367 10.0237 11.633 10.0237 11.872 9.929L20.5 6.477V16ZM20.5 4.323L11.5 7.923L2.5 4.323V2H20.5V4.323Z"
                                            fill="#526EFF"
                                        />
                                    </svg>
                                    {data?.user_active ? data.user_email : data.corporate_email}
                                </div>
                            </div>
                            <ul
                                className="prodct-listing invoice"
                                style={{
                                    borderTop: '1px solid #dee2e6',
                                    paddingTop: '14px',
                                    marginTop: '30px',
                                }}
                            >
                                <li>
                                    <strong>
                                        <svg
                                            width="18"
                                            height="22"
                                            viewBox="0 0 18 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9 10C9.98891 10 10.9556 9.70676 11.7779 9.15735C12.6001 8.60794 13.241 7.82705 13.6194 6.91342C13.9978 5.99979 14.0969 4.99446 13.9039 4.02455C13.711 3.05465 13.2348 2.16373 12.5355 1.46447C11.8363 0.765206 10.9454 0.289002 9.97545 0.0960759C9.00555 -0.0968503 8.00021 0.00216642 7.08658 0.380605C6.17295 0.759043 5.39206 1.39991 4.84265 2.22215C4.29324 3.0444 4 4.0111 4 5C4.00159 6.3256 4.52888 7.59644 5.46622 8.53378C6.40356 9.47112 7.67441 9.99841 9 10ZM9 2C9.59334 2 10.1734 2.17595 10.6667 2.50559C11.1601 2.83524 11.5446 3.30377 11.7716 3.85195C11.9987 4.40013 12.0581 5.00333 11.9424 5.58527C11.8266 6.16722 11.5409 6.70177 11.1213 7.12132C10.7018 7.54088 10.1672 7.8266 9.58527 7.94236C9.00333 8.05811 8.40013 7.9987 7.85195 7.77164C7.30377 7.54458 6.83524 7.16006 6.50559 6.66671C6.17595 6.17337 6 5.59335 6 5C6 4.20435 6.31607 3.44129 6.87868 2.87868C7.44129 2.31607 8.20435 2 9 2ZM1 22H17C17.2652 22 17.5196 21.8946 17.7071 21.7071C17.8946 21.5196 18 21.2652 18 21V17C17.9984 15.6744 17.4711 14.4036 16.5338 13.4662C15.5964 12.5289 14.3256 12.0016 13 12H5C3.67441 12.0016 2.40356 12.5289 1.46622 13.4662C0.528882 14.4036 0.00158786 15.6744 0 17V21C0 21.2652 0.105357 21.5196 0.292893 21.7071C0.48043 21.8946 0.734784 22 1 22ZM2 17C2 16.2044 2.31607 15.4413 2.87868 14.8787C3.44129 14.3161 4.20435 14 5 14H13C13.7956 14 14.5587 14.3161 15.1213 14.8787C15.6839 15.4413 16 16.2044 16 17V20H2V17Z"
                                                fill="#526EFF"
                                            />
                                        </svg>{' '}
                                        {/* {data.corporate_name ||
                                            `${data.first_name} ${data.last_name}`} */}
                                        {data?.user_active
                                            ? data?.first_name + ' ' + data?.last_name
                                            : data?.corporate_name}
                                    </strong>
                                    <div className="d-flex" style={{ paddingLeft: '25px' }}>
                                        <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 22 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M11 0C8.82441 0 6.69767 0.645139 4.88873 1.85383C3.07979 3.06253 1.66989 4.7805 0.83733 6.79048C0.00476617 8.80047 -0.213071 11.0122 0.211367 13.146C0.635804 15.2798 1.68345 17.2398 3.22183 18.7782C4.76021 20.3166 6.72022 21.3642 8.85401 21.7886C10.9878 22.2131 13.1995 21.9952 15.2095 21.1627C17.2195 20.3301 18.9375 18.9202 20.1462 17.1113C21.3549 15.3023 22 13.1756 22 11C21.9966 8.08368 20.8365 5.28778 18.7744 3.22563C16.7122 1.16347 13.9163 0.00344047 11 0ZM11 20C9.21997 20 7.47992 19.4722 5.99987 18.4832C4.51983 17.4943 3.36628 16.0887 2.68509 14.4442C2.0039 12.7996 1.82567 10.99 2.17294 9.24419C2.5202 7.49836 3.37737 5.89471 4.63604 4.63604C5.89472 3.37737 7.49836 2.5202 9.24419 2.17293C10.99 1.82567 12.7996 2.0039 14.4442 2.68508C16.0887 3.36627 17.4943 4.51983 18.4832 5.99987C19.4722 7.47991 20 9.21997 20 11C19.9974 13.3861 19.0483 15.6738 17.361 17.361C15.6738 19.0483 13.3861 19.9974 11 20ZM17 11C17 11.2652 16.8946 11.5196 16.7071 11.7071C16.5196 11.8946 16.2652 12 16 12H11C10.7348 12 10.4804 11.8946 10.2929 11.7071C10.1054 11.5196 10 11.2652 10 11V5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4C11.2652 4 11.5196 4.10536 11.7071 4.29289C11.8946 4.48043 12 4.73478 12 5V10H16C16.2652 10 16.5196 10.1054 16.7071 10.2929C16.8946 10.4804 17 10.7348 17 11Z"
                                                fill="#526EFF"
                                            />
                                        </svg>

                                        <strong>Promised Time {data?.promiseTime}</strong>
                                    </div>
                                </li>
                                <li>
                                    <strong>
                                        <svg
                                            width="18"
                                            height="22"
                                            viewBox="0 0 18 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M1 22H17C17.2652 22 17.5196 21.8946 17.7071 21.7071C17.8946 21.5196 18 21.2652 18 21V5C18 4.73478 17.8946 4.48043 17.7071 4.29289C17.5196 4.10536 17.2652 4 17 4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5V21C0 21.2652 0.105357 21.5196 0.292893 21.7071C0.48043 21.8946 0.734784 22 1 22ZM2 6H16V20H2V6ZM15 0C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1C16 1.26522 15.8946 1.51957 15.7071 1.70711C15.5196 1.89464 15.2652 2 15 2H3C2.73478 2 2.48043 1.89464 2.29289 1.70711C2.10536 1.51957 2 1.26522 2 1C2 0.734784 2.10536 0.48043 2.29289 0.292893C2.48043 0.105357 2.73478 0 3 0H15ZM13 9V11C13 11.2652 12.8946 11.5196 12.7071 11.7071C12.5196 11.8946 12.2652 12 12 12H6C5.73478 12 5.48043 11.8946 5.29289 11.7071C5.10536 11.5196 5 11.2652 5 11V9C5 8.73478 5.10536 8.48043 5.29289 8.29289C5.48043 8.10536 5.73478 8 6 8C6.26522 8 6.51957 8.10536 6.70711 8.29289C6.89464 8.48043 7 8.73478 7 9V10H11V9C11 8.73478 11.1054 8.48043 11.2929 8.29289C11.4804 8.10536 11.7348 8 12 8C12.2652 8 12.5196 8.10536 12.7071 8.29289C12.8946 8.48043 13 8.73478 13 9Z"
                                                fill="#526EFF"
                                            />
                                        </svg>
                                        Invoice ID #{data?.cartId}
                                    </strong>
                                    <div className="d-flex" style={{ paddingLeft: '25px' }}>
                                        <svg
                                            width="22"
                                            height="16"
                                            viewBox="0 0 22 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M21 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V15C0 15.2652 0.105357 15.5196 0.292893 15.7071C0.48043 15.8946 0.734784 16 1 16H21C21.2652 16 21.5196 15.8946 21.7071 15.7071C21.8946 15.5196 22 15.2652 22 15V1C22 0.734784 21.8946 0.48043 21.7071 0.292893C21.5196 0.105357 21.2652 0 21 0ZM20 12.184C19.5813 12.3326 19.201 12.5727 18.8869 12.8869C18.5727 13.201 18.3326 13.5813 18.184 14H3.816C3.66741 13.5813 3.42729 13.201 3.11314 12.8869C2.79898 12.5727 2.4187 12.3326 2 12.184V3.816C2.4187 3.66741 2.79898 3.42729 3.11314 3.11314C3.42729 2.79898 3.66741 2.4187 3.816 2H18.184C18.3326 2.4187 18.5727 2.79898 18.8869 3.11314C19.201 3.42729 19.5813 3.66741 20 3.816V12.184ZM11 4C10.2089 4 9.43552 4.2346 8.77772 4.67412C8.11992 5.11365 7.60723 5.73836 7.30448 6.46927C7.00173 7.20017 6.92252 8.00444 7.07686 8.78036C7.2312 9.55628 7.61216 10.269 8.17157 10.8284C8.73098 11.3878 9.44372 11.7688 10.2196 11.9231C10.9956 12.0775 11.7998 11.9983 12.5307 11.6955C13.2616 11.3928 13.8864 10.8801 14.3259 10.2223C14.7654 9.56448 15 8.79113 15 8C15 6.93913 14.5786 5.92172 13.8284 5.17157C13.0783 4.42143 12.0609 4 11 4ZM11 10C10.6044 10 10.2178 9.8827 9.88886 9.66294C9.55996 9.44318 9.30362 9.13082 9.15224 8.76537C9.00087 8.39991 8.96126 7.99778 9.03843 7.60982C9.1156 7.22186 9.30608 6.86549 9.58579 6.58579C9.86549 6.30608 10.2219 6.1156 10.6098 6.03843C10.9978 5.96126 11.3999 6.00087 11.7654 6.15224C12.1308 6.30362 12.4432 6.55996 12.6629 6.88886C12.8827 7.21776 13 7.60444 13 8C13 8.53043 12.7893 9.03914 12.4142 9.41421C12.0391 9.78929 11.5304 10 11 10ZM6 8C6 8.26522 5.89464 8.51957 5.70711 8.70711C5.51957 8.89464 5.26522 9 5 9H4C3.73478 9 3.48043 8.89464 3.29289 8.70711C3.10536 8.51957 3 8.26522 3 8C3 7.73478 3.10536 7.48043 3.29289 7.29289C3.48043 7.10536 3.73478 7 4 7H5C5.26522 7 5.51957 7.10536 5.70711 7.29289C5.89464 7.48043 6 7.73478 6 8ZM19 8C19 8.26522 18.8946 8.51957 18.7071 8.70711C18.5196 8.89464 18.2652 9 18 9H17C16.7348 9 16.4804 8.89464 16.2929 8.70711C16.1054 8.51957 16 8.26522 16 8C16 7.73478 16.1054 7.48043 16.2929 7.29289C16.4804 7.10536 16.7348 7 17 7H18C18.2652 7 18.5196 7.10536 18.7071 7.29289C18.8946 7.48043 19 7.73478 19 8Z"
                                                fill="#526EFF"
                                            />
                                        </svg>
                                        <strong>Total ${data?.price}</strong>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div
                            className="modal-footer"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '1rem',
                            }}
                        >
                            <Button
                                onClick={() => {
                                    // setConfirm(false);
                                    handleSendInvoice();
                                }}
                                startIcon={<img src={invoiceSrc} alt="editCheck" />}
                                style={{ width: 'fit-content' }}
                            >
                                Send Invoice
                            </Button>
                            <Button
                                variant="secondary"
                                startIcon={<CancelOutlined className="pColor" />}
                                style={{ width: 'fit-content' }}
                                onClick={() => closeDialog()}
                            >
                                Cancel
                            </Button>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="modal-header">
                            <h5 className="modal-title" id="invoicemsgModalLabel">
                                Message
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => closeDialog()}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="invoice-header">
                                <p className="text-center f-18">
                                    The invoice has been successfully sent
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <Button
                                startIcon={<CheckCircleOutline />}
                                style={{ width: 'fit-content' }}
                                onClick={() => closeDialog()}
                            >
                                Okay
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default AddInvoice;
